<template>
	<div class="ir-quote-wrapper">
		<div class="quote-content quote-content--full old-view-style">
			<div v-if="stockData" class="quote-row" @click="clickQuoteRow">
				<div :class="['stocktip', getMarket]">
					{{ getMarket.toUpperCase() }}
				</div>

				<div class="quote-row-main" :style="computedStockColorByLang(stockData.change)">
					<div class="quote-row-price">
						{{ divideByHundred(stockData.closePrice) }}
					</div>
					<div class="quote-row-increase">
						<!-- TODO 上涨下降箭头 c-rise-fall-range -->
						<span class="increase-span">{{ appendPlusIfPositive(stockData.change) }}</span>
						<span class="increase-span">{{ formatChangePct(stockData.changePct) }}</span>
					</div>
				</div>

				<div class="quote-row-cutoff">
					<span>{{ $t('enterprise.common-a.updated') }}：</span>
					<span class="word-regular">{{ stockData.tradingDay }}</span>
				</div>
			</div>
		</div>

		<VanPopupStockInfo ref="vanPopupStockInfoRef" :snapshot="currStoreData" />
	</div>
</template>

<script setup>
import VanPopupStockInfo from '@rebuild/materials/shared/quote/van-popup-stockInfo.vue';
import { ref, computed, onMounted } from 'vue';
import { useStore } from '@/utils/vue-api';
import { computedStockColorByLang } from '@/assets/js/i18n';
import { useQuoteService } from '@rebuild/materials/shared/quote/useQuoteService';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import { deepClone } from '@/utils/api';

const { divideByHundred, appendPlusIfPositive, formatChangePct } = useStockVO();

// Store
const store = useStore();
const getIrBaseInfo = computed(() => store.getters.getIrBaseInfo);

// Reactive data
const stockData = ref(null);
const currStoreData = ref({});

const getIrFullCode = computed(() => store.getters.getIrFullCode);

const isUsStock = computed(() => {
	return getIrFullCode.value.startsWith('us');
});

const getMarket = computed(() => getIrBaseInfo.value?.market || '');

const { loadQuoteData } = useQuoteService();

const refresh = async done => {
	// 标准行情
	const res = await loadQuoteData();
	if (res) {
		stockData.value = res;
		currStoreData.value = res;
	} else {
		stockData.value = null;
	}

	done && done();
};

onMounted(() => {
	refresh();
});

const vanPopupStockInfoRef = ref(null);
const clickQuoteRow = () => {
	if (isUsStock.value) return;
	currStoreData.value = deepClone(stockData.value);
	vanPopupStockInfoRef.value.handleShowPopup();
};
</script>

<style lang="less" scoped>
.ir-quote-wrapper {
	position: relative;
	border-radius: 0.04rem;
	background: #fff;

	.quote-content {
		position: relative;
		display: flex;
		justify-content: space-between;

		.quote-row {
			position: relative;
			padding: 0.14rem 0.12rem;
			background: #f9f9f9 !important;

			& + .quote-row {
				margin-top: 0.12rem;
			}

			.stocktip {
				position: absolute;
				left: 0;
				top: 0;
				padding: 0.02rem 0.03rem;
				font-size: 0.08rem;
				color: #fff;
				border-radius: 0.04rem 0 0.04rem;
				&.sh {
					background: #fa4646;
				}
				&.hk {
					background: #446dff;
				}
			}
			.quote-row-price {
				color: #333;
				font-family: 'Repair-Regular';
				font-size: 0.22rem;
				font-style: normal;
				font-weight: 700;
				line-height: 0.22rem; /* 100% */
			}
			.quote-row-increase {
				display: flex;
				align-items: center;

				.increase-span {
					margin-left: 0.04rem;
					font-family: 'Repair-Regular';
					font-size: 0.12rem;
					font-style: normal;
					font-weight: 500;
					line-height: 0.17rem;

					& + .increase-span {
						margin-left: 0.08rem;
					}
				}
			}
			.quote-row-cutoff {
				color: #999;
				font-size: 0.1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.14rem;

				.word-regular {
					font-family: 'Repair-Regular';
				}
			}
		}

		&--half {
			.quote-row {
				width: calc(50% - 0.07rem);
			}
			.quote-row-increase {
				margin-top: 0.08rem;

				.increase-span:first-child {
					margin-left: 0;
				}
			}
			.quote-row-cutoff {
				margin-top: 0.12rem;
			}
		}
		&--full {
			.quote-row {
				flex: 1;
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			.quote-row-main {
				display: flex;
				align-items: baseline;
			}
			.quote-row-increase {
				margin-left: 0.08rem;
			}
		}
	}

	.old-view-style {
		display: block;
		justify-content: initial;
	}

	.quote-chat {
		padding-bottom: 12px;
	}
}
</style>
